import { createContext, useEffect, useState } from 'react'

import { authService } from 'auth'
import env from 'env'

type AuthProviderProps = {
  children: React.ReactElement
}

export const AuthProviderContext = createContext<{ isAuthReady: boolean }>({ isAuthReady: false })

export const AuthProvider = ({ children }: AuthProviderProps): React.ReactElement => {
  const [authConfig, setAuthConfig] = useState({ isAuthReady: false })

  useEffect(() => {
    const initAuth = async () => {
      await authService.init({
        domain: env.AUTH_PROVIDER_DOMAIN,
        clientId: env.AUTH_APP_CLIENT_ID,
        cacheLocation: 'localstorage',
        useRefreshTokens: true,
        authorizationParams: {
          scope: env.AUTH_APP_SCOPE,
          audience: env.AUTH_API_IDENTIFIER,
        },
      })
    }

    initAuth().finally(() => {
      setAuthConfig({ isAuthReady: true })
    })
  }, [])

  return <AuthProviderContext.Provider value={authConfig}>{children}</AuthProviderContext.Provider>
}
